if (!customElements.get("media-cards-slider")) {
  class MediaCardsSlider extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.init();
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("orientationchange", this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);
    }

    init() {
      this.hasMapLayout = this.classList.contains("store-locator__map-cards");
      this.updateSwiper();
      this.initTooltips();
    }

    initTooltips() {
      const tooltipTriggers = this.querySelectorAll(
        ".tooltip-trigger"
      );

      tooltipTriggers.forEach(trigger => {
        const content = trigger.nextElementSibling;
        if (
          !content ||
          !content.classList.contains("tooltip-content")
        )
          return;
        if (trigger.dataset.tooltipInitialized) return;
        trigger.dataset.tooltipInitialized = "true";

        const closeButton = content.querySelector(".tooltip-drawer__close");

        if (closeButton) {
          closeButton.addEventListener("click", event => {
            event.stopPropagation();
            closeAllTooltips();
          });
        }

        trigger.addEventListener("click", event => {
          event.stopPropagation();
          const wasActive = content.classList.contains("is-active");
          closeAllTooltips();
          if (!wasActive) {
            content.classList.add("is-active");

            if (DeviceDetector.isMobile()) {
              content.originalParent = content.parentElement;
              content.originalNextSibling =
                content.nextElementSibling;
              document.body.appendChild(content);
              document.body.classList.add("tooltip-mobile-open");
            }
          }
        });
      });
      this.querySelectorAll(".tooltip-content").forEach(content => {
        content.addEventListener("click", event =>
          event.stopPropagation()
        );
      });

      const closeAllTooltips = () => {
        document
          .querySelectorAll(".tooltip-content.is-active")
          .forEach(activeContent => {
            activeContent.classList.remove("is-active");

            if (activeContent.originalParent) {
              activeContent.originalParent.insertBefore(
                activeContent,
                activeContent.originalNextSibling
              );
              delete activeContent.originalParent;
              delete activeContent.originalNextSibling;
            }
          });
        document.body.classList.remove("tooltip-mobile-open");
      };

      if (!window.hasTooltipGlobalListener) {
        document.addEventListener("click", closeAllTooltips);
        window.hasTooltipGlobalListener = true;
      }
    }

    handleResize() {
      this.updateSwiper();
    }

    updateSwiper() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      if (this.hasMapLayout && DeviceDetector.isDesktop()) {
        return;
      }

      const swiperSettings = {
        slidesPerView: 1,
        navigation: {
          nextEl: `.swiper-button--next-${this.dataset.sectionId}`,
          prevEl: `.swiper-button--prev-${this.dataset.sectionId}`
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        spaceBetween: parseInt(this.dataset.spaceBetween) || 12,
      };

      if (!this.hasMapLayout) {
        swiperSettings.breakpoints = {
          1024: {
            slidesPerView: 4,
          },
          0: {
            slidesPerView: 2,
          }
        };
      }

      this.slider = new Swiper(this, swiperSettings);

      const handleMobileVideo = () => {
        if (window.innerWidth >= 1024) return;
        this.querySelectorAll('.media-card').forEach(card => {
          const video = card.querySelector('.media-card__hover--video video');
          if (!video) return;
          const isActive = card.closest('.swiper-slide')?.classList.contains('swiper-slide-active');
          if (isActive) {
            video.play();
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      };

      this.slider.on('slideChange transitionEnd', () => {
        const slides = this.querySelectorAll(
          ".media-card.swiper-slide"
        );
        slides.forEach((slide) => {
          slide.style.display = "block";
        });
        handleMobileVideo();
      });

      requestAnimationFrame(() => handleMobileVideo());
    }
  }

  customElements.define("media-cards-slider", MediaCardsSlider);
}
